<template>
    <v-card
        class="mx-auto itemCard pa-3"
        outlined
    >
        <v-row no-gutters>
            <v-col cols="12" md="4" class="mr-1">
                <v-text-field
                    hide-details="auto"
                    :label="$t('page.eventDetails.raceList.race-name')"
                    v-model="raceName"
                    :error-messages="
                        isError.raceName ? $t('page.eventDetails.raceList.is-errors.' + isError.message.raceName) : ''
                        "
                    style="margin: 10px 0"
                    outlined
                    dense
                    @input="sendMessage('raceName')"
                    :placeholder="placeholder.raceName"
                ></v-text-field>
            </v-col>
            <v-col class="mr-1">
                <TimeField 
                    :model="startTime"
                    :label="$t('page.eventDetails.raceList.start-time')"
                    @saveTime="saveTime"
                    :message="$t('page.eventDetails.raceList.format-time')"
                />
            </v-col>
            <v-col class="mr-1">
                <TimeField 
                    :model="raceLenght"
                    :label="$t('page.eventDetails.raceList.race-lenght')"
                    @saveTime="saveTime"
                    :message="$t('page.eventDetails.raceList.format-time')"
                />
            </v-col>
            <v-col class="mr-1">
                <v-text-field
                    hide-details="auto"
                    :label="$t('page.eventDetails.raceList.track-lenght')"
                    v-model="trackLenght"
                    :error-messages="
                        isError.trackLenght ? $t('page.eventDetails.raceList.is-errors.' + isError.message.trackLenght) : ''
                        "
                    style="margin: 10px 0"
                    outlined
                    dense
                    @input="sendMessage('trackLenght')"
                    :placeholder="placeholder.trackLenght"
                ></v-text-field>
            </v-col>
            <v-col class="mr-1">
                <DateField 
                    :model="startDate"
                    :label="$t('page.eventDetails.raceList.start-date')"
                    @saveDate="saveDate"
                    :message="$t('page.eventDetails.raceList.format-date')"
                />
            </v-col>
            <v-col cols="12" md="2">
                <v-text-field
                    hide-details="auto"
                    :label="$t('page.eventDetails.raceList.scoring-mode')"
                    v-model="scoringMode"
                    :error-messages="
                        isError.scoringMode ? $t('page.eventDetails.raceList.is-errors.' + isError.message.scoringMode) : ''
                        "
                    style="margin: 10px 0"
                    outlined
                    dense
                    @input="sendMessage('scoringMode')"
                    :placeholder="placeholder.scoringMode"
                ></v-text-field>
            </v-col>
        </v-row>
        <v-row no-gutters v-if="!dropdown || open">
            <v-col cols="12" md="10">
                <v-select
                    v-model="classes"
                    :items="classItems"
                    item-text="text"
                    item-value="id"
                    dense
                    outlined
                    :label="$t('page.eventDetails.raceList.class')"
                    @change="sendMessage('classes')"
                    return-object
                    style="margin: 10px 0"
                    :no-data-text="$t('common.no_data')"
                ></v-select>
            </v-col>
        </v-row>

        <v-row no-gutters v-if="!dropdown || open">
            <v-expansion-panels
                flat
                accordion
            >
                <v-expansion-panel  >
                    <v-expansion-panel-header>
                    <template v-slot:default="{ open }">
                        <v-row>
                            <v-col cols="2">
                            {{$t('page.eventDetails.raceList.advanced-settings')}} &nbsp;
                            <i class="fas fa-caret-right" v-if="open"></i>
                            <i class="fas fa-caret-down" v-if="!open"></i>
                            
                            </v-col>
                        </v-row>
                    </template>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content style="background-color: var(--v-lighten-base) !important;">
                        <RaceAdvanceSetting :item="item"/>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-row>
        <a class="controlOpen" @click="controlOpen" v-if="dropdown">
            <i :class="!open ? 'far fa-chevron-down' : 'far fa-chevron-up'"></i>
        </a>
    </v-card>
</template>

<script>
import TimeField from "@/components/general/TimeField.vue";
import DateField from "@/components/general/DateField.vue";
import RaceAdvanceSetting from "@/components/dashboard/eventDetails/raceList/RaceAdvanceSetting.vue";

export default {
  components: {
      TimeField,
      DateField,
      RaceAdvanceSetting
  },
  props: { item: Object, dropdown: Boolean },
  data () {
    return {
        raceName: "Bla bla bla",
        startTime: "00:20:00",
        raceLenght: "16:30:00",
        trackLenght: "2.00KMS",
        startDate: "2021-05-16",
        scoringMode: "Bla bla / Bla",
        classes: [],
        classItems: [],
        open: false,
        isError: {
            raceName: false,
            startTime: false,
            raceLenght: false,
            trackLenght: false,
            startDate: false,
            scoringMode: false,
            classes: false,
            message: {
                raceName: "",
                startTime: "",
                raceLenght: "",
                trackLenght: "",
                startDate: "",
                scoringMode: "",
                classes: ""
            }
        },
    };
  },
  computed: {
      placeholder: function () {
          return {
              raceName: this.$t("page.eventDetails.raceList.placeholder.race-name"),
              startTime: this.$t("page.eventDetails.raceList.placeholder.start-time"),
              raceLength: this.$t("page.eventDetails.raceList.placeholder.race-lenght"),
              trackLenght: this.$t("page.eventDetails.raceList.placeholder.track-lenght"),
              startDate: this.$t("page.eventDetails.raceList.placeholder.start-date"),
              scoringMode: this.$t("page.eventDetails.raceList.placeholder.scoring-mode")
          };
      }
  },
  methods: {
      expansion(event){
           event.currentTarget.classList.contains('v-expansion-panel-header--active')
      },
      sendMessage() {
      },
      saveTime() {
      },
      saveDate() {
      },
      controlOpen() {
          this.open = !this.open;
      },
      transitionStep1(el) {
        // set the block height at the moment of its appearance
        el.style.height = el.scrollHeight + 'px'
      },
      transitionStep2(el) {
        // remove inline styles from the block after animation of its appearance
        el.style.height = ''
      },
      transitionStep3(el) {
        // set the height of the block at the beginning of its disappearance animation
        el.style.height = el.scrollHeight + 'px'
      },
      transitionStep4(el) {
        // remove inline styles from the block after the animation of its disappearance
        el.style.height = ''
      }
  },
  created () {
      this.raceName = this.$escapeHtml.decode(this.item.raceName);
      this.startTime = this.item.startTime;
      this.raceLenght = this.item.raceLength;
      this.trackLenght = this.item.trackLenght;
      this.startDate = this.item.startDay;
      this.scoringMode = this.item.scoringMode;
  }
}
</script>

<style lang="scss" scoped>
.itemCard {
    background-color: var(--v-lighten-base) !important;
    > .row {
        max-width: calc(100% - 30px);
        margin: 0 auto;
    }
}    
.controlOpen {position: absolute; top: 5px; right: 15px;}
.main-nav {
    overflow: hidden;
    -webkit-transition: height 0.3s ease;
    transition: height 0.3s ease;
}
.main-nav-enter {
    height: 0;
}
.main-nav-leave-to {
    height: 0 !important;
}

</style>

<style >
.v-expansion-panel-header__icon{
    display: none !important;
}
</style>